import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { timer } from 'rxjs';
import {
  Button, Icon, Timeline, Collapse,
} from 'antd';
import {
  NotifButtonWrapper, HistoryDrawer, HistoryClearButton, HistoryLabel, HistoryEventList,
  HistoryTriangleUp, HistoryTriangleDown, HistoryDrawerCutOff,
} from './styles';
import theme from '../../styles';
import {
  EVENTS_SUMMARY, EVENTS_SUMMARY_VIEWED,
} from '../../plannerConfig';
import baseActions from '../../actions';

// I'm reluctent to have redux applied to component, but I am even more reluctent
// to make a container for a simple component. Thus, I put redux stuff in this
// component.
const mapStateToProps = state => ({
  [EVENTS_SUMMARY]: state[EVENTS_SUMMARY].data,
});

const mapDispatchToProps = {
  get: baseActions.get,
  post: baseActions.post,
};

const ShowHistoryAlert = ({ list }) => (
  <Timeline>
    {
      list && list.length > 0 && list.map(item => (
        <Timeline.Item
          color={theme.colors.events[item.eventType]}
          key={item.groupId}
        >
          <Collapse
            bordered={false}
          >
            <Collapse.Panel
              showArrow={false}
              header={(
                <>
                  <HistoryLabel>
                    {item.heading}
                  </HistoryLabel>
                  <div>
                    <sup>
                      <b>{item.owner} - </b>
                      {
                        moment(item.eventsTo).format('YYYY-MM-DD, HH:mm')
                      }
                    </sup>
                  </div>
                </>
              )}
            >
              <HistoryEventList>
                {
                  item.events.map(eventItem => (
                    <li key={eventItem.eventDatetime}>
                      <div>{eventItem.eventDescription}</div>
                      <small>
                        {moment(eventItem.eventDatetime).format('YYYY-MM-DD, HH:mm')}
                      </small>
                    </li>
                  ))
                }
              </HistoryEventList>
            </Collapse.Panel>
          </Collapse>
        </Timeline.Item>
      ))
    }

  </Timeline>
);

class HistoryAlert extends Component {
  state = {
    drawer: false,
    eventHistoryFrom: -1,
    eventHistorySize: 12,
  };

  componentDidMount = () => {
    this.enableEventPolling();
  }

  enableEventPolling = () => {
    // Polling for event summary.
    const eventPoll = timer(0, 10000)
      .subscribe(() => this.getEventSummary());

    const handleVisibilityChange = () => {
      if (document.hidden) {
        eventPoll.unsubscribe();
      } else if (eventPoll.isStopped) {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        this.enableEventPolling();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange, false);
  }

  handleClickToToggleDrawer = () => {
    const { drawer } = this.state;
    this.setState({ drawer: !drawer }, this.handleClickToIndicateViewed);
  }

  handleClickToCloseDrawer = () => {
    this.setState({ drawer: false }, this.handleClickToIndicateViewed);
  }

  trackEventSummaryParams = (isNext) => {
    const { eventsSummary: { results } } = this.props;
    const { eventHistorySize } = this.state;
    const eventGroupId = isNext
      ? (results[0] && results[0].groupId + eventHistorySize)
      : (results[0] && results[0].groupId - eventHistorySize);
    this.setState(
      { eventHistoryFrom: eventGroupId },
      () => this.getEventSummary(),
    );
  }

  handleClickEventNext = () => this.trackEventSummaryParams(true);

  handleClickEventPrev = () => this.trackEventSummaryParams(false);

  handleClickToClearEvents = () => {
    const { post, eventsSummary: { results } } = this.props;
    const { groupId } = results[0];
    post(
      [EVENTS_SUMMARY],
      {
        routeParams: {
          scenario: 0,
          groupId,
        },
        body: {
          scenario_id: 0,
          group_id: groupId,
        },
      },
    );
  }

  handleClickToIndicateViewed = () => {
    const { post } = this.props;
    this.setState({ eventHistoryFrom: -1 }); // revert the poll to get the latest events.
    post(
      [EVENTS_SUMMARY_VIEWED],
      {
        routeParams: {
          scenario: 0,
        },
        callback: () => this.getEventSummary(),
      },
    );
  }

  getEventSummary = () => {
    const { get } = this.props;
    const { eventHistoryFrom, eventHistorySize } = this.state;
    get(
      [EVENTS_SUMMARY],
      {
        routeParams: {
          scenario: 0,
          groupId: eventHistoryFrom,
          size: eventHistorySize,
        },
      },
    );
  }

  render() {
    const { eventsSummary } = this.props;
    const { drawer } = this.state;
    const {
      results = [], unseenCount, hasNextPage, hasPrevPage,
    } = eventsSummary;
    return (
      <>
        <NotifButtonWrapper
          fontSize={24}
          offset={[12, 0]}
          {...(eventsSummary && unseenCount > 0) && { count: unseenCount }}
          ml={4}
        >
          <Button
            type="ghost"
            size="large"
            onClick={this.handleClickToToggleDrawer}
          >
            <Icon type="bell" theme="twoTone" twoToneColor="#fff" />
          </Button>
        </NotifButtonWrapper>

        <HistoryDrawer
          width="280"
          placement="right"
          onClose={this.handleClickToCloseDrawer}
          visible={drawer}
          mask={false}
          maskClosable
        >
          <HistoryDrawerCutOff top="0">
            <HistoryTriangleUp
              disabled={!hasNextPage}
              {...(hasNextPage) && { onClick: this.handleClickEventNext }}
            />
          </HistoryDrawerCutOff>
          <ShowHistoryAlert
            list={results}
          />
          <HistoryDrawerCutOff bottom="0">
            <HistoryTriangleDown
              disabled={!hasPrevPage}
              {...(hasPrevPage) && { onClick: this.handleClickEventPrev }}
            />
            <HistoryClearButton
              onClick={this.handleClickToClearEvents}
              disabled={!eventsSummary || results.length === 0}
            >
              Clear
            </HistoryClearButton>
          </HistoryDrawerCutOff>
        </HistoryDrawer>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HistoryAlert);
